<div *ngIf="havePermission">
  <app-reservation-audit-filter (search)="handleSearch()"></app-reservation-audit-filter>
  <app-reservation-audit-results *ngIf="showResults"></app-reservation-audit-results>
</div>
